export default {
    root: {
        class: ['flex items-stretch', 'w-full', 'std-border', 'rounded-lg']
    }
};
